import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLgComponent } from './simple-icons-lg.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLgComponent ],
    exports:      [ SimpleIconsLgComponent ],
    bootstrap:    []
})
export class SimpleIconsLgModule {}
